import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../../../common/config";

export const resetPasswordService = createApi({
  reducerPath: "reset Password",
  baseQuery,
  endpoints: (builder) => ({
    resetPassword: builder.mutation({
      query: (formdata) => {
        console.log("form", formdata);
        return {
          url: `/api/users/updatepassword/${formdata?.id}`,
          method: "PUT",
          body: formdata,
        };
      },
    }),
  }),
});
export const { useResetPasswordMutation } = resetPasswordService;
